import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-pernod-ricard',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './pernod-ricard.component.html',
  styleUrl: './pernod-ricard.component.scss'
})
export class PernodRicardComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.pernodRicard;
}
